module.exports = __webpack_public_path__ + "img/rujia.e068f4bb.jpg";